export default {
  name: 'Line',
  displayName: {
    en: 'Line',
    ja: '線',
  },
  icon: 'icon.png',
  defaultWidth: 56,
  defaultHeight: 1,
  resizeX: true,
  resizeY: true,
  props: [],
  style: {
    backgroundColor: true,
    borderStyle: true,
  },
};
